// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e9254cc5","453":"dde484a2","455":"c44ca8bd","977":"0e22106f"}[chunkId] + ".chunk.js";
};